import {
  ApplicationView,
  StartControllerScope,
  useController,
} from '@aha-app/mvc';
import React from 'react';
import WidgetsController from '../../../controllers/WidgetsController';
import TimerController from './controllers/TimerController';
import TimerInput from './TimerInput';
import TimerCountdown from './TimerCountdown';
import styles from './Timer.module.css';

const TimerContainer: React.FC = () => {
  const widgetsController = useController(WidgetsController);
  const widget = widgetsController.timerWidget;

  return <ControlledSidePanelComponent widget={widget} />;
};

const TimerSidePanelComponent: React.FC = () => {
  const controller = useController(TimerController);

  const { active, widget } = controller.state;

  return (
    <div className={styles.timerContainer}>
      {active && widget ? (
        <TimerCountdown widget={widget} />
      ) : (
        <TimerInput widget={widget} startDuration={widget?.startDuration} />
      )}
    </div>
  );
};

const ControlledSidePanelComponent = StartControllerScope(
  TimerController,
  ApplicationView(TimerSidePanelComponent)
);

export default ApplicationView(TimerContainer);
